export const LOCAL_STORAGE_KEY = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  SHIFT_ACTIVE: 'shiftActive',
  CUSTOMER_LOOKUP_DETAILED_TABS: 'customerLookupTabs',
  MINIMIZED_TICKETS: 'minimizedTickets',
  MINIMIZED_TICKET_DATA: 'minimizedTicketData',
  SEARCH_CRITERIA: 'searchCriteria',

  CT_DEPARTMENT: 'dept',
  CT_COMMANDER: 'cmd',
  CT_WORKER: 'worker',
};
